// Länder für den Wohnort eines Eigentümers (ISO 3166-1 alpha-2, deutsche Namen). Deutschland und die Nachbarländer
// zuerst, danach alphabetisch; gleiche Liste wie im Backend (owners.CountryName).
export const countries: { code: string; name: string }[] = [
  { code: 'DE', name: 'Deutschland' },
  { code: 'AT', name: 'Österreich' },
  { code: 'CH', name: 'Schweiz' },
  { code: 'NL', name: 'Niederlande' },
  { code: 'BE', name: 'Belgien' },
  { code: 'LU', name: 'Luxemburg' },
  { code: 'FR', name: 'Frankreich' },
  { code: 'DK', name: 'Dänemark' },
  { code: 'PL', name: 'Polen' },
  { code: 'CZ', name: 'Tschechien' },
  { code: 'AU', name: 'Australien' },
  { code: 'BA', name: 'Bosnien und Herzegowina' },
  { code: 'BR', name: 'Brasilien' },
  { code: 'BG', name: 'Bulgarien' },
  { code: 'FI', name: 'Finnland' },
  { code: 'GR', name: 'Griechenland' },
  { code: 'IE', name: 'Irland' },
  { code: 'IL', name: 'Israel' },
  { code: 'IT', name: 'Italien' },
  { code: 'CA', name: 'Kanada' },
  { code: 'KZ', name: 'Kasachstan' },
  { code: 'HR', name: 'Kroatien' },
  { code: 'LI', name: 'Liechtenstein' },
  { code: 'MT', name: 'Malta' },
  { code: 'NO', name: 'Norwegen' },
  { code: 'PT', name: 'Portugal' },
  { code: 'RO', name: 'Rumänien' },
  { code: 'RU', name: 'Russland' },
  { code: 'SE', name: 'Schweden' },
  { code: 'RS', name: 'Serbien' },
  { code: 'SK', name: 'Slowakei' },
  { code: 'SI', name: 'Slowenien' },
  { code: 'ES', name: 'Spanien' },
  { code: 'ZA', name: 'Südafrika' },
  { code: 'TH', name: 'Thailand' },
  { code: 'TR', name: 'Türkei' },
  { code: 'UA', name: 'Ukraine' },
  { code: 'HU', name: 'Ungarn' },
  { code: 'AE', name: 'Vereinigte Arabische Emirate' },
  { code: 'US', name: 'Vereinigte Staaten' },
  { code: 'GB', name: 'Vereinigtes Königreich' },
  { code: 'CY', name: 'Zypern' },
];

// residenceText: Wohnort als Klartext für Karten und Listen.
export function residenceText(r: { mode: string; address?: { line: string } | null }): string {
  if (r.mode === 'ADDRESS') return r.address?.line || 'andere Anschrift';
  if (r.mode === 'PROPERTY') return r.address?.line ? `wohnt im Objekt (${r.address.line})` : 'wohnt im Objekt';
  return 'wohnt woanders – Anschrift unbekannt';
}

// propertyLine: Anschrift eines Objekts in einer Zeile.
export function propertyLine(p: { street: string | null; house_number: string | null; postal_code: string | null; city: string | null }): string {
  return (
    [[p.street, p.house_number].filter(Boolean).join(' '), [p.postal_code, p.city].filter(Boolean).join(' ')].filter(Boolean).join(', ') ||
    'Objekt ohne Anschrift'
  );
}

export const propertyTypeLabels: Record<string, string> = {
  HOUSE: 'Haus',
  APARTMENT: 'Wohnung',
  COMMERCIAL: 'Gewerbe',
  LAND: 'Grundstück',
  OTHER: 'Sonstiges',
};

export const roleLabels: Record<string, string> = {
  OWNER: 'Eigentümer',
  CO_OWNER: 'Miteigentümer',
  HEIR: 'Erbe',
  PROXY: 'Bevollmächtigter',
  MANAGER: 'Verwalter',
};
